import type {
  BasicBooking,
  BasicBooking_sailing_route_importSettings_accompaniedList,
} from "../../common/graphql/fragments/gql/BasicBooking";
import { ImportExportType } from "../../gql/graphql";
import { isBookingEditable } from "../update-form/utils/bookingUtils";

export const shouldShowEnsLinkTogetherWithEnvelopeId = (
  booking: BasicBooking,
  settings: BasicBooking_sailing_route_importSettings_accompaniedList,
) =>
  settings.type === ImportExportType.EnvelopeId &&
  settings.showEnsLink &&
  (isBookingEditable(booking) || booking.importReference.ensConfirmed);
